import { render, staticRenderFns } from "./CreatedByWinfakt.vue?vue&type=template&id=0985b645&scoped=true"
import script from "./CreatedByWinfakt.vue?vue&type=script&lang=ts"
export * from "./CreatedByWinfakt.vue?vue&type=script&lang=ts"
import style0 from "./CreatedByWinfakt.vue?vue&type=style&index=0&id=0985b645&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0985b645",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0985b645')) {
      api.createRecord('0985b645', component.options)
    } else {
      api.reload('0985b645', component.options)
    }
    module.hot.accept("./CreatedByWinfakt.vue?vue&type=template&id=0985b645&scoped=true", function () {
      api.rerender('0985b645', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/CreatedByWinfakt.vue"
export default component.exports